import { render, staticRenderFns } from "./DescriptionBox.vue?vue&type=template&id=e8930c96&lang=html&"
import script from "./DescriptionBox.vue?vue&type=script&lang=js&"
export * from "./DescriptionBox.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports